import Vue from 'vue';
import VueRouter from 'vue-router';
import About from '@/views/About.vue';
import PlanningFinishView from '@/views/planning/PlanningFinishView.vue';
import PlanningDetailView from '@/views/planning/PlanningDetailView.vue';
import Planning from '@/views/Planning.vue';
import QuoteOverview from '@/views/quote/QuoteOverview.vue';
import VisitReportEditView from '@/views/planning/VisitReportEditView.vue';
import Quote from '@/views/quote2/Quote.vue';
import QuoteClientCreate from '@/views/quote2/components/QuoteClientCreate.vue';
import WorkOrder from '@/views/work-order/WorkOrder.vue';
import WorkOrderOverview from '@/views/work-order/WorkOrderOverview.vue';
import InventoryOverview from '@/views/inventory/InventoryOverview.vue';
import InventoryUpsert from '@/views/inventory/InventoryUpsert.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
    });
};

const routes = [
    { path: '/planning', name: 'planning', component: Planning },
    { path: '/about', name: 'about', component: About },
    { path: '/planning/:calendarItemId/detail*', component: PlanningDetailView, props: true },
    { path: '/planning/:calendarItemId/finish', component: PlanningFinishView, props: true },
    { path: '/planning-item-report/edit', component: VisitReportEditView },
    { path: '/quote/overview', component: QuoteOverview },
    { path: '*', component: Planning },
    { path: '/quote2/upsert', component: Quote },
    { path: '/quote2/upsert/:quoteId', component: Quote, props: true },
    { path: '/quote2/client/create', component: QuoteClientCreate },
    { path: '/workOrder/upsert', component: WorkOrder },
    { path: '/workOrder/upsert/:workOrderId', component: WorkOrder, props: true },
    { path: '/workOrder/overview', component: WorkOrderOverview },
    { path: '/inventory/overview', component: InventoryOverview },
    { path: '/inventory/upsert', component: InventoryUpsert },
    { path: '/inventory/upsert/:inventoryId', component: InventoryUpsert, props: true },
];

const router = new VueRouter({
    routes,
});

export default router;
